import type { Article } from '@flocasts/flosports30-types/dist/entity'
import type { FloResponse } from '@flocasts/flosports30-types/dist/flo-rest-api/response'
import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { LOGGER_SERVICE } from '../logger/logger.config'
import { LoggerService } from '../logger/logger.interface'
import { Observable } from 'rxjs'
import { EXPERIENCE_API_LEGACY_CORE_ARTICLES_PATH, EXPERIENCE_API_VERSION } from '../app.config'

@Injectable({
  providedIn: 'root'
})
export class ArticleDataService {
  // prettier-ignore
  constructor(
    @Inject(LOGGER_SERVICE) private readonly log: LoggerService,
    private readonly http: HttpClient
  ) {}

  public getArticle(id: number | string, showDraft = false): Observable<FloResponse<Article, {}>> {
    this.log.trace(`ArticleDataService: Requesting Article`, {
      id,
      showDraft,
      version: EXPERIENCE_API_VERSION
    })

    const params: Record<string, string> = showDraft ? { future: '1', status: '0,1,2' } : {}

    return this.http.get<FloResponse<Article, {}>>(`${EXPERIENCE_API_LEGACY_CORE_ARTICLES_PATH}/${id}`, {
      params: { ...params, version: EXPERIENCE_API_VERSION }
    })
  }

  /**
   * TODO: Go back to paginated-fetching, instead of increasing limit.
   * @see {@link (https://flocasts.atlassian.net/browse/CXP-3115) }
   */
  public getArticles(
    limit: number = 10,
    useOfp = false,
    navId?: string
  ): Observable<FloResponse<ReadonlyArray<Article>, {}>> {
    this.log.trace(`ArticleDataService: Requesting Article List`, {})
    return this.http.get<FloResponse<ReadonlyArray<Article>, {}>>(EXPERIENCE_API_LEGACY_CORE_ARTICLES_PATH, {
      params: {
        limit: String(limit),
        version: EXPERIENCE_API_VERSION,
        useOfp,
        ...(!!navId && { nav_id: navId })
      }
    })
  }
}
